import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import styled from "styled-components"; //eslint-disable-line
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnDark";
import MainFeature1 from "components/features/TwoColWithButton.js";
// import MainFeature2 from "components/features/TwoColSingleFeatureWithStats.js";
// import MainFeature3 from "components/features/TwoColSingleFeatureWithStats2.js";
import Features from "components/features/ThreeColSimple.js";
// import Features from "components/features/ThreeColWithSideImage.js";
import TeamCardGrid from "components/cards/ProfileThreeColGrid.js";

import SupportIconImage from "images/support-icon.svg";
import ShieldIconImage from "images/shield-icon.svg";
import CustomerLoveIconImage from "images/simple-icon.svg";
import DashedBorderSixFeatures from "components/features/DashedBorderSixFeatures";
import TwoColSingleFeatureWithStats from "components/features/TwoColSingleFeatureWithStats";
import TwoColumnWithVideo from "components/hero/TwoColumnWithVideo";
import Fintech1 from "../../images/fintech1.png"
import Fintech2 from "../../images/fintech2.png"
import ContactUs from "pages/ContactUs";
import TwoColContactUsWithIllustrationFullForm from "components/forms/TwoColContactUsWithIllustrationFullForm";
import GetStarted from "components/cta/GetStarted";
import SEO from "components/SEO";

const Subheading = tw.span`uppercase tracking-wider text-sm`;
export default ({ roundedHeaderButton }) => {
  return (
    <AnimationRevealPage>
        <SEO
title="Fintech Page" 
description="Fintech Page"
/>
      <TwoColumnWithVideo
       heading="Fintech Software Development Company"
       buttonRounded={false}
       primaryButtonText="Request free consultation"
       primaryButtonUrl = "https://calendly.com/solutions-tbnw/30min?month=2024-11"
       description="At Metromidas, we empower businesses to transform their financial services with our innovative, state-of-the-art Fintech software solutions. By partnering with our leading Fintech software development company, you can create robust, scalable, and secure financial platforms that drive operational efficiency, foster growth, and ensure long-term success.

Discover our customer-centric approach to Fintech software development and let us help you design tailored solutions that perfectly align with your unique business requirements."
       imageSrc={Fintech1}
       />

<MainFeature1
        subheading={<Subheading></Subheading>}
        heading="Our Fintech Software Development Services"
        buttonRounded={false}
        primaryButtonText="Contact Us"
        primaryButtonUrl = "/contactus"
        description="We offer various Fintech software development services to empower your finance enterprise with advanced and innovative solutions. Our Fintech software development company holds strong expertise in both finance and technology industries, delivering exceptional Fintech solutions."
        imageSrc={Fintech2}
        textOnLeft={false}
      />
       <GetStarted />

<TwoColContactUsWithIllustrationFullForm />
      <Footer />
    </AnimationRevealPage>
    
  );
};
